"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachedPaymentPlans = exports.UpdateScheduledPaymentsDto = exports.CancelFutureInstallmentsDto = exports.FutureInstallmentsIdsDto = exports.ScheduledPaymentDto = exports.CreateScheduledPaymentsDto = exports.BasicInstallmentDataDto = exports.CalcPaymentPlanDto = exports.CreatePaymentPlanDto = exports.PaymentPlanDto = exports.PaymentPlanScheduleDto = void 0;
const organization_dto_1 = require("../../organization/dto/organization.dto");
class PaymentPlanScheduleDto {
}
exports.PaymentPlanScheduleDto = PaymentPlanScheduleDto;
class PaymentPlanDto {
}
exports.PaymentPlanDto = PaymentPlanDto;
class CreatePaymentPlanDto extends PaymentPlanDto {
}
exports.CreatePaymentPlanDto = CreatePaymentPlanDto;
class CalcPaymentPlanDto extends PaymentPlanDto {
}
exports.CalcPaymentPlanDto = CalcPaymentPlanDto;
class BasicInstallmentDataDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.BasicInstallmentDataDto = BasicInstallmentDataDto;
class CreateScheduledPaymentsDto extends BasicInstallmentDataDto {
}
exports.CreateScheduledPaymentsDto = CreateScheduledPaymentsDto;
class ScheduledPaymentDto {
}
exports.ScheduledPaymentDto = ScheduledPaymentDto;
class FutureInstallmentsIdsDto {
}
exports.FutureInstallmentsIdsDto = FutureInstallmentsIdsDto;
class CancelFutureInstallmentsDto extends FutureInstallmentsIdsDto {
}
exports.CancelFutureInstallmentsDto = CancelFutureInstallmentsDto;
class UpdateScheduledPaymentsDto {
}
exports.UpdateScheduledPaymentsDto = UpdateScheduledPaymentsDto;
class CachedPaymentPlans {
}
exports.CachedPaymentPlans = CachedPaymentPlans;
//# sourceMappingURL=payment-plan.dto.js.map